import { render, staticRenderFns } from "./invasion-time-remaining.vue?vue&type=template&id=5a362d88&lang=pug&"
import script from "./invasion-time-remaining.vue?vue&type=script&lang=js&"
export * from "./invasion-time-remaining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports